<template>
  <div class="enterprise-banner">
    <i class="fa fa-lock"></i>
    <h5>Upgrade to use Account provisioning</h5>
    <p class="contents">
      With Account provisioning, you can create accounts for your team members individually or in bulk. Skip the hassle
      of invites and directly create member logins, passwords, and even set whether they receive Hubstaff emails.
      Account provisioning can be purchased by upgrading to the Enterprise plan.
    </p>
    <div>
      <a
        class="btn btn-primary"
        :href="planUrl"
      >
        View plans & add-ons
      </a>
      <a
        class="btn btn-naked"
        href="https://support.hubstaff.com/account-provisioning/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more about Account provisioning
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CorporateAppUpsell',
  props: {
    planUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
